const templates = {
    TSHIRT_3D: {
        'parts': [
            {
                'key': 'front',
                'parts': [
                    'front-1',
                ],
                'name': 'Thân trước',
            },
            {
                'key': 'back',
                'parts': [
                    'back-1',
                ],
                'name': 'Thân sau',
            },
            {
                'key': 'neck',
                'name': 'Bo cổ',
                'parts': [
                    'back-2',
                    'front-2',
                    'back-3',
                ],
            },
            {
                'key': 'left_sleeve',
                'name': 'Tay trái',
                'parts': [
                    'sleeve-1',
                ],
            },
            {
                'key': 'right_sleeve',
                'name': 'Tay phải',
                'parts': [
                    'sleeve-2',
                ],
            },
        ],
    },
    SWEATSHIRT_3D: {
        'parts': [
            {
                'key': 'front',
                'parts': [
                    'front-1',
                ],
                'name': 'Thân trước',
            },
            {
                'key': 'back',
                'parts': [
                    'back-1',
                ],
                'name': 'Thân sau',
            },
            {
                'key': 'neck',
                'name': 'Bo cổ',
                'parts': [
                    'back-2',
                    'front-2',
                    'back-3',
                ],
            },
            {
                'key': 'left_sleeve',
                'name': 'Tay trái',
                'parts': [
                    'sleeve-2',
                ],
            },
            {
                'key': 'left_hem_sleeve',
                'name': 'Bo tay trái',
                'parts': [
                    'sleeve-21',
                ],
            },
            {
                'key': 'right_sleeve',
                'name': 'Tay phải',
                'parts': [
                    'sleeve-1',
                ],
            },
            {
                'key': 'right_hem_sleeve',
                'name': 'Bo tay phải',
                'parts': [
                    'sleeve-11',
                ],
            },
            {
                'key': 'bottom_hem',
                'name': 'Bo thân',
                'parts': [
                    'front-3',
                    'back-4',
                ],
            },
        ],
    },
    ZIP_HOODIE_3D: {
        'parts': [
            {
                'key': 'right_front',
                'parts': [
                    'front-11',
                ],
                'name': 'Thân trước phải',
            },
            {
                'key': 'left_front',
                'parts': [
                    'front-12',
                ],
                'name': 'Thân trước trái',
            },
            {
                'key': 'back',
                'parts': [
                    'back-1',
                ],
                'name': 'Thân sau',
            },
            {
                'key': 'bottom_hem',
                'name': 'Bo thân',
                'parts': [
                    'front-22',
                    'back-2',
                    'front-21',
                ],
            },
            {
                'key': 'left_sleeve',
                'name': 'Tay trái',
                'parts': [
                    'sleeve-2',
                ],
            },
            {
                'key': 'left_hem_sleeve',
                'name': 'Bo tay trái',
                'parts': [
                    'sleeve-21',
                ],
            },
            {
                'key': 'right_sleeve',
                'name': 'Tay phải',
                'parts': [
                    'sleeve-1',
                ],
            },
            {
                'key': 'right_hem_sleeve',
                'name': 'Bo tay phải',
                'parts': [
                    'sleeve-11',
                ],
            },
            {
                'key': 'right_pocket',
                'name': 'Túi phải',
                'parts': [
                    'front-31',
                ],
            },
            {
                'key': 'left_pocket',
                'name': 'Túi trái',
                'parts': [
                    'front-32',
                ],
            },
            {
                'key': 'hood',
                'name': 'Mũ',
                'parts': [
                    'hood-1',
                ],
            },
        ],
    },
    HOODIE_3D: {
        'parts': [
            {
                'key': 'front',
                'parts': [
                    'front-1',
                ],
                'name': 'Thân trước',
            },
            {
                'key': 'back',
                'parts': [
                    'back-1',
                ],
                'name': 'Thân sau',
            },
            {
                'key': 'bottom_hem',
                'name': 'Bo thân',
                'parts': [
                    'front-2',
                    'back-2',
                ],
            },
            {
                'key': 'left_sleeve',
                'name': 'Tay trái',
                'parts': [
                    'sleeve-2',
                ],
            },
            {
                'key': 'left_hem_sleeve',
                'name': 'Bo tay trái',
                'parts': [
                    'sleeve-21',
                ],
            },
            {
                'key': 'right_sleeve',
                'name': 'Tay phải',
                'parts': [
                    'sleeve-1',
                ],
            },
            {
                'key': 'right_hem_sleeve',
                'name': 'Bo tay phải',
                'parts': [
                    'sleeve-11',
                ],
            },
            {
                'key': 'pocket',
                'name': 'Túi',
                'parts': [
                    'front-3',
                ],
            },
            {
                'key': 'hood',
                'name': 'Mũ',
                'parts': [
                    'hood-1',
                ],
            },
        ],
    },
    'ZIP HOODIE 3D': {
        'parts': [
            {
                'key': 'right_front',
                'parts': [
                    'front-11',
                ],
                'name': 'Thân trước phải',
            },
            {
                'key': 'left_front',
                'parts': [
                    'front-12',
                ],
                'name': 'Thân trước trái',
            },
            {
                'key': 'back',
                'parts': [
                    'back-1',
                ],
                'name': 'Thân sau',
            },
            {
                'key': 'bottom_hem',
                'name': 'Bo thân',
                'parts': [
                    'front-22',
                    'back-2',
                    'front-21',
                ],
            },
            {
                'key': 'left_sleeve',
                'name': 'Tay trái',
                'parts': [
                    'sleeve-2',
                ],
            },
            {
                'key': 'left_hem_sleeve',
                'name': 'Bo tay trái',
                'parts': [
                    'sleeve-21',
                ],
            },
            {
                'key': 'right_sleeve',
                'name': 'Tay phải',
                'parts': [
                    'sleeve-1',
                ],
            },
            {
                'key': 'right_hem_sleeve',
                'name': 'Bo tay phải',
                'parts': [
                    'sleeve-11',
                ],
            },
            {
                'key': 'right_pocket',
                'name': 'Túi phải',
                'parts': [
                    'front-31',
                ],
            },
            {
                'key': 'left_pocket',
                'name': 'Túi trái',
                'parts': [
                    'front-32',
                ],
            },
            {
                'key': 'hood',
                'name': 'Mũ',
                'parts': [
                    'hood-1',
                ],
            },
        ],
    },
    'Zip Hoodie 3D': {
        'parts': [
            {
                'key': 'right_front',
                'parts': [
                    'front-11',
                ],
                'name': 'Thân trước phải',
            },
            {
                'key': 'left_front',
                'parts': [
                    'front-12',
                ],
                'name': 'Thân trước trái',
            },
            {
                'key': 'back',
                'parts': [
                    'back-1',
                ],
                'name': 'Thân sau',
            },
            {
                'key': 'bottom_hem',
                'name': 'Bo thân',
                'parts': [
                    'front-22',
                    'back-2',
                    'front-21',
                ],
            },
            {
                'key': 'left_sleeve',
                'name': 'Tay trái',
                'parts': [
                    'sleeve-2',
                ],
            },
            {
                'key': 'left_hem_sleeve',
                'name': 'Bo tay trái',
                'parts': [
                    'sleeve-21',
                ],
            },
            {
                'key': 'right_sleeve',
                'name': 'Tay phải',
                'parts': [
                    'sleeve-1',
                ],
            },
            {
                'key': 'right_hem_sleeve',
                'name': 'Bo tay phải',
                'parts': [
                    'sleeve-11',
                ],
            },
            {
                'key': 'right_pocket',
                'name': 'Túi phải',
                'parts': [
                    'front-31',
                ],
            },
            {
                'key': 'left_pocket',
                'name': 'Túi trái',
                'parts': [
                    'front-32',
                ],
            },
            {
                'key': 'hood',
                'name': 'Mũ',
                'parts': [
                    'hood-1',
                ],
            },
        ],
    },
    TSHIRT_02: {
        'parts': [
            {
                'key': 'front',
                'parts': [
                    'front-1',
                ],
                'name': 'Thân trước',
            },
            {
                'key': 'back',
                'parts': [
                    'back-1',
                ],
                'name': 'Thân sau',
            },
            {
                'key': 'neck',
                'name': 'Bo cổ',
                'parts': [
                    'back-2',
                    'front-2',
                    'back-3',
                ],
            },
            {
                'key': 'left_sleeve',
                'name': 'Tay trái',
                'parts': [
                    'sleeve-1',
                ],
            },
            {
                'key': 'right_sleeve',
                'name': 'Tay phải',
                'parts': [
                    'sleeve-2',
                ],
            },
        ],
    },
    SW_18: {
        'parts': [
            {
                'key': 'front',
                'parts': [
                    'front-1',
                ],
                'name': 'Thân trước',
            },
            {
                'key': 'back',
                'parts': [
                    'back-1',
                ],
                'name': 'Thân sau',
            },
            {
                'key': 'neck',
                'name': 'Bo cổ',
                'parts': [
                    'back-2',
                    'front-2',
                    'back-3',
                ],
            },
            {
                'key': 'left_sleeve',
                'name': 'Tay trái',
                'parts': [
                    'sleeve-2',
                ],
            },
            {
                'key': 'left_hem_sleeve',
                'name': 'Bo tay trái',
                'parts': [
                    'sleeve-21',
                ],
            },
            {
                'key': 'right_sleeve',
                'name': 'Tay phải',
                'parts': [
                    'sleeve-1',
                ],
            },
            {
                'key': 'right_hem_sleeve',
                'name': 'Bo tay phải',
                'parts': [
                    'sleeve-11',
                ],
            },
            {
                'key': 'bottom_hem',
                'name': 'Bo thân',
                'parts': [
                    'front-3',
                    'back-4',
                ],
            },
        ],
    },
    ZIP_HD_18: {
        'parts': [
            {
                'key': 'right_front',
                'parts': [
                    'front-11',
                ],
                'name': 'Thân trước phải',
            },
            {
                'key': 'left_front',
                'parts': [
                    'front-12',
                ],
                'name': 'Thân trước trái',
            },
            {
                'key': 'back',
                'parts': [
                    'back-1',
                ],
                'name': 'Thân sau',
            },
            {
                'key': 'bottom_hem',
                'name': 'Bo thân',
                'parts': [
                    'front-22',
                    'back-2',
                    'front-21',
                ],
            },
            {
                'key': 'left_sleeve',
                'name': 'Tay trái',
                'parts': [
                    'sleeve-2',
                ],
            },
            {
                'key': 'left_hem_sleeve',
                'name': 'Bo tay trái',
                'parts': [
                    'sleeve-21',
                ],
            },
            {
                'key': 'right_sleeve',
                'name': 'Tay phải',
                'parts': [
                    'sleeve-1',
                ],
            },
            {
                'key': 'right_hem_sleeve',
                'name': 'Bo tay phải',
                'parts': [
                    'sleeve-11',
                ],
            },
            {
                'key': 'right_pocket',
                'name': 'Túi phải',
                'parts': [
                    'front-31',
                ],
            },
            {
                'key': 'left_pocket',
                'name': 'Túi trái',
                'parts': [
                    'front-32',
                ],
            },
            {
                'key': 'hood',
                'name': 'Mũ',
                'parts': [
                    'hood-1',
                ],
            },
        ],
    },
    HD_18: {
        'parts': [
            {
                'key': 'front',
                'parts': [
                    'front-1',
                ],
                'name': 'Thân trước',
            },
            {
                'key': 'back',
                'parts': [
                    'back-1',
                ],
                'name': 'Thân sau',
            },
            {
                'key': 'bottom_hem',
                'name': 'Bo thân',
                'parts': [
                    'front-2',
                    'back-2',
                ],
            },
            {
                'key': 'left_sleeve',
                'name': 'Tay trái',
                'parts': [
                    'sleeve-2',
                ],
            },
            {
                'key': 'left_hem_sleeve',
                'name': 'Bo tay trái',
                'parts': [
                    'sleeve-21',
                ],
            },
            {
                'key': 'right_sleeve',
                'name': 'Tay phải',
                'parts': [
                    'sleeve-1',
                ],
            },
            {
                'key': 'right_hem_sleeve',
                'name': 'Bo tay phải',
                'parts': [
                    'sleeve-11',
                ],
            },
            {
                'key': 'pocket',
                'name': 'Túi',
                'parts': [
                    'front-3',
                ],
            },
            {
                'key': 'hood',
                'name': 'Mũ',
                'parts': [
                    'hood-1',
                ],
            },
        ],
    },
}

export default function (template) {
    return templates[template] || {parts: []}
}
